import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/studio/components/StudioAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/studio/components/StudioCTA.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/studio/components/StudioHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/studio/components/StudioInstitution.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/studio/components/StudioSchedule.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/app/studio/components/StudioStudents.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/mac/development/web_projects/codigo/wisly/src/components/Header.tsx");
